<template>
  <div class="row m-0 v-clean mt-2">
    <div class="col-md-12 pt-0 pb-0">
      <label-required-field class="m-0" label="QUANTIDADE" />
      <v-text-field-default type="number" label="" v-model="quantity" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <label-required-field class="m-0" label="DATA DO SERVIÇO" />
      <v-text-field-default type="date" label="" v-model="date" />
    </div>
    <!-- <div class="col-md-12 pt-0 pb-0">
      <label-required-field class="m-0" label="REPETIR?" />
      <v-select
        :items="[
          { value: 'NAO_SE_REPETE', text: 'NÃO SE REPETE' },
          { value: 'MAIS_DE_UMA_VEZ', text: 'MAIS DE UMA VEZ' },
        ]"
        dense
        label=""
        outlined
        hide-details
        item-value="value"
        item-text="text"
        v-model="repeat"
        @change="handleChangeRepeat"
      />
    </div>
    <div class="col-md-6 pt-0 pb-0" v-if="repeat == 'MAIS_DE_UMA_VEZ'">
      <label-required-field class="m-0" label="PERIODICIDADE" />
      <v-select
        :items="[
          { value: 'SEMANAL', text: 'SEMANAL' },
          { value: 'QUINZENAL', text: 'QUINZENAL' },
          { value: 'MENSAL', text: 'MENSAL' },
          { value: 'BIMESTRAL', text: 'BIMESTRAL' },
          { value: 'TRIMESTRAL', text: 'TRIMESTRAL' },
          { value: 'SEMESTRAL', text: 'SEMESTRAL' },
          { value: 'ANUAL', text: 'ANUAL' },
        ]"
        dense
        label=""
        outlined
        hide-details
        item-value="value"
        item-text="text"
        v-model="periodicity"
      />
    </div>
    <div v-if="repeat == 'MAIS_DE_UMA_VEZ'" class="col-md-6 pt-0 pb-0">
      <label-required-field class="m-0" label="QUANTAS VEZES" />
      <v-text-field-default type="number" label="" v-model="how_many_times" />
    </div> -->
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn-save
        :disabled="loading"
        :loading="loading"
        text="SALVAR"
        @click="execute"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../Components/VBtnSave.vue";

import LabelRequiredField from "../../../Components/LabelRequiredField.vue";

import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    VBtnSave,
    LabelRequiredField,
    VTextFieldDefault,
  },

  props: {
    service: Object,
  },

  data() {
    return {
      quantity: 1,
      date: moment().format("YYYY-MM-DD"),

      repeat: "NAO_SE_REPETE",
      periodicity: "MENSAL",
      how_many_times: 1,

      loading: false,

      errors: [],
    };
  },

  created() {
    let { date, quantity, repeat, how_many_times, periodicity } = this.service;
    this.date = moment(date).format("YYYY-MM-DD");
    this.quantity = quantity;
    this.repeat = repeat;
    if (repeat == "MAIS_DE_UMA_VEZ") {
      this.how_many_times = how_many_times;
      this.periodicity = periodicity;
    }
  },

  methods: {
    moment,

    handleChangeRepeat() {
      this.how_many_times = 1;
    },

    async execute() {
      try {
        this.loading = true;

        const {
          service: { id },
          quantity,
          date,
          repeat,
          how_many_times,
          periodicity,
        } = this;

        let params = {
          id,
          quantity,
          date,
          repeat,
          how_many_times,
          periodicity,
        };

        const response = await api.patch("/rest-home/resident/service", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("edit");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
